/**
 * MessageContext `name` values excluded from the dashboard “Chat” message list
 * (threads linked to an AI audit row or a document).
 */
export const DASHBOARD_EXCLUDED_ASSOCIATION_CONTEXT_NAMES = [
  'aiAuditId',
  'documentId',
] as const;
